import {SurveyQuestionInterface, SurveyFocusArea} from "./interfaces";

export const translateQuestion = (language: string, question: SurveyQuestionInterface, name: string) => {

  let questionName = question.translationsName[language];
  if (questionName) {
    if (questionName.startsWith("X ")) {
      return name + questionName.substring(1);
    } else {
      return questionName;
    }
  }
  return question.name
}

export const translateSection = (language: string, area?: SurveyFocusArea) => {

  if (area) {
    let sectionName = area.translationsName[language];
    if (sectionName) {
      return sectionName;
    }
    return area.name
  }

  return "N/A";
}
